<form [formGroup]="contactCtrl">
	<mat-form-field class="full-width fn-size-18" floatLabel="never">
		<input
			#contactInput
			[formControl]="contactCtrl"
			[matAutocomplete]="auto"
			matInput
			placeholder="Email Address"
		/>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event)"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoading" fxLayoutAlign="center center">
				<mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoading">
				<mat-option *ngFor="let contact of listOfContacts" [value]="contact">
					{{ displayFn(contact) }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</form>
